import { render } from "./errorcomponent.vue?vue&type=template&id=de138788"
import script from "./errorcomponent.vue?vue&type=script&lang=js"
export * from "./errorcomponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/julien/build/build/p2p-exchange/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__